import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/Login.vue';
import ProjectList from '@/views/ProjectList.vue';
import Workbench from '@/views/Workbench.vue';
import AppConfig from '@/views/AppConfig.vue';
import PrivateLib from '@/views/PrivateLib.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    redirect: '/projects'
  },
  {
    path: '/projects',
    name: 'ProjectList',
    component: ProjectList
  },
  {
    path: '/settings/model',
    name: 'AppConfig',
    component: AppConfig
  },
  {
    path: '/private-lib',
    name: 'PrivateLib',
    component: PrivateLib
  },
  {
    path: '/workbench/:id',
    name: 'Workbench',
    component: Workbench,
    props: true
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('MIAOBI_TOKEN');
  if (to.meta.public) {
    // 已登录时访问登录页，直接跳首页
    if (token && to.name === 'Login') {
      return next('/');
    }
    return next();
  }
  if (!token) {
    return next({ name: 'Login', query: { redirect: to.fullPath } });
  }
  next();
});

export default router;
